import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Dilucion/filtrarDilucion`, method: 'POST', body: values, token: token})
}
